<template>
    <div :id="`wangeditor-${name}`" class="wang-editor" ref="wang-editor"></div>
</template>
<script>
import moment from "moment";
import { loadScript } from "../service/requestApi.js";
import $ from "jquery";

export default {
    props: {
        name: String
    },
    data() {
        return {
            editor: null,
            loading: false,
            htmlShow: false
        };
    },
    components: {},
    methods: {
        getContent() {
            return this.editor.txt.html();
        },
        setContent(val) {
            if (this.editor) {
                this.editor.txt.html(val);
            } else {
                console.log("wangEditor未初始化");
            }
        },
        htmlTagHandler(editorId) {
            $(editorId + " .w-e-toolbar").prepend(
                '<div class="w-e-menu"><a class="_wangEditor_btn_html" href="javascript:;">html</a></div>'
            );
            const $toolBtn = $(
                editorId + " .w-e-toolbar ._wangEditor_btn_html"
            );
            $toolBtn.off("click").on("click", () => {
                if (this.htmlShow) {
                    $toolBtn.removeClass("active");
                    let textareaVal = $(
                        editorId + " ._wangEditor_html_area"
                    ).val();
                    this.editor.txt.html(textareaVal);
                    this.$emit('editor-change', textareaVal);
                    $(editorId + " ._wangEditor_html_area").remove();
                } else {
                    $toolBtn.addClass("active");
                    $(editorId + " .w-e-text-container").append(
                        '<textarea class="_wangEditor_html_area"></textarea>'
                    );
                    $(editorId + " ._wangEditor_html_area").val(
                        this.editor.txt.html()
                    );
                }
                this.htmlShow = !this.htmlShow;
            });
        }
    },
    computed: {},
    created() {},
    async mounted() {
        const _this = this;
        const editorId = `#wangeditor-${this.name}`;
        this.loading = true;
        await loadScript(
            // TODO unpkg.com时不时需要梯子才能正常使用，先拉一份源码到公司OSS，后续走npm安装新版。
            // "//unpkg.com/wangeditor@3.1.1/release/wangEditor.min.js"
            "//img-fe.tengzhihh.com/file/cbad4e67-6d57-42b1-9468-7a4b3c58a78b.js"
        );
        this.editor = new wangEditor(editorId);
        this.editor.customConfig.menus = [
            // 'head',  // 标题
            "bold", // 粗体
            "fontSize", // 字号
            "fontName", // 字体
            "italic", // 斜体
            "underline", // 下划线
            "strikeThrough", // 删除线
            "foreColor", // 文字颜色
            "backColor", // 背景颜色
            "link", // 插入链接
            "list", // 列表
            "justify", // 对齐方式
            "quote", // 引用
            // 'emoticon',  // 表情
            "image", // 插入图片
            // 'table',  // 表格
            // 'video',  // 插入视频
            // 'code',  // 插入代码
            "undo", // 撤销
            "redo" // 重复
        ];
        this.editor.customConfig.onchange = function (newHtml) {
            _this.$emit('editor-change', newHtml);
        }
        this.editor.create();
        this.htmlTagHandler(editorId);
        this.loading = false;
        this.$emit("init-complete");
    },
    destroyed() {
        try {
            this.editor = null;
            console.log("wangEditor 销毁");
        } catch (e) {}
    }
};
</script>
<style lang="less">
.wang-editor {
    width: 100%;
    background-color: #fff;
    // height: 500px;
}
._wangEditor_btn_html {
    color: #999;
    text-decoration: none;
    font-weight: 600;
    width: 35px;
    display: block;
    &.active {
        font-weight: 800;
        color: #333;
        text-decoration: underline;
    }
}
._wangEditor_html_area {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border: 0;
    color: #606266;
    line-height: 22px;
}
</style>



// WEBPACK FOOTER //
// src/components/wangEditor.vue